import React, { useEffect, useState } from 'react';
import {
    Table,
    Space,
    Button,
    Image,
    Popconfirm,
    Modal,
    Alert,
    Input,Typography,
    Select,
    Grid,
    List,
    Card
} from 'antd';
import {
    EditOutlined,
    DeleteOutlined,
    DownloadOutlined,
} from '@ant-design/icons';
import axios from 'axios';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import { EllipsisOutlined } from '@ant-design/icons';
import { Dropdown, Menu } from 'antd';
import { useMediaQuery } from 'react-responsive';
import ActualizarProducto from '../components/ActualizarProducto';

const { Search } = Input;
const { Option } = Select;
const { useBreakpoint } = Grid;

const MisProductos = () => {
          const screens = useBreakpoint();
    const isMobile = !screens.md; // md = 768px
    const [productos, setProductos] = useState([]);
    const [productosFiltrados, setProductosFiltrados] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchText, setSearchText] = useState('');
    const [filters, setFilters] = useState({ categoria: null, marca: null, genero: null });
    const [successMessage, setSuccessMessage] = useState(null);

    const [dropdownVisible, setDropdownVisible] = useState(false);

    const [modalVisible, setModalVisible] = useState(false);
    const [productoSeleccionado, setProductoSeleccionado] = useState(null);
    console.log(productos)
    const mostrarModalEdicion = (producto) => {
        setProductoSeleccionado(producto);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
        setProductoSeleccionado(null);
    };



    useEffect(() => {
        fetchProductos();
    }, []);

    const fetchProductos = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get('https://elarigestion-production.up.railway.app/api/mis-productos', {
                headers: { Authorization: token },
            });

            // Ordenar por código de producto antes de guardar en el estado
            const productosOrdenados = res.data.productos.sort((a, b) => {
                if (a.codigoProducto < b.codigoProducto) return -1;
                if (a.codigoProducto > b.codigoProducto) return 1;
                return 0;
            });

            setProductos(productosOrdenados);
        } catch (error) {
            Modal.error({
                title: 'Error al cargar los productos',
                content: error.message,
            });
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        aplicarFiltros();
    }, [productos, searchText, filters]);

    const aplicarFiltros = () => {
        const texto = searchText.toLowerCase();

        const filtrados = productos.filter((p) => {
            const coincideTexto =
                p.nombre.toLowerCase().includes(texto) ||
                (p.Categorium?.nombre?.toLowerCase().includes(texto) ?? false);

            const coincideCategoria = !filters.categoria || p.Categorium?.nombre === filters.categoria;
            const coincideMarca = !filters.marca || p.Marca?.nombre === filters.marca;

            return coincideTexto && coincideCategoria && coincideMarca;
        });

        setProductosFiltrados(filtrados);
    };

    const eliminarProducto = async (id) => {
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`https://elarigestion-production.up.railway.app/api/producto/${id}`, {
                headers: { Authorization: token },
            });
            setSuccessMessage('Producto eliminado exitosamente');
            fetchProductos();
        } catch (error) {
            Modal.error({
                title: 'Error al eliminar producto',
                content: error.message,
            });
        }
    };

    const exportToExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Productos');

        worksheet.columns = [
            { header: 'Codigo del producto', key: 'codigoProducto', width: 30 },
            { header: 'Categoría', key: 'categoria', width: 30 },
            { header: 'Nombre', key: 'nombre', width: 30 },
            { header: 'Marca', key: 'marca', width: 25 },
            { header: 'Talles', key: 'talles', width: 25 },
            { header: 'Colores', key: 'colores', width: 25 },

            { header: 'Genero', key: 'genero', width: 25 },

            { header: 'Stock', key: 'stock', width: 25 },
            { header: 'Precio c/u', key: 'precio', width: 15 },





        ];

        productosFiltrados.forEach((p) => {
            worksheet.addRow({
                nombre: p.nombre || '-',
                codigoProducto: p.codigoProducto || '-',
                categoria: p.Categorium?.nombre || '-',

                marca: p.Marca?.nombre || '-',
                talles: p.talles?.map((t) => t.nombre).join(", ") || "-",

                colores: p.colores?.map((t) => t.nombre).join(", ") || "-",

                genero: p.nombre || '-',

                stock: p.stock || '-',
                precio:`$${p.precio}` || '-',


            });
        });
    worksheet.eachRow((row, rowNumber) => {
            if (rowNumber !== 1) {
                row.eachCell(cell => {
                    cell.alignment = {
                        vertical: 'middle',
                        horizontal: 'left',
                        indent: 1,
                    };
                });
            }
        });
        worksheet.getRow(1).eachCell((cell) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '000000' },
            };
            cell.font = { color: { argb: 'FFFFFF' }, bold: true };
            cell.alignment = { vertical: 'middle', horizontal: 'center' };
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        saveAs(blob, 'Mis-Productos.xlsx');
    };

    const categorias = [...new Set(productos.map(p => p.Categorium?.nombre).filter(Boolean))];
    const marcas = [...new Set(productos.map(p => p.Marca?.nombre).filter(Boolean))];
    const genero = [...new Set(productos.map(p => p.Genero?.nombre).filter(Boolean))];


    const columns = [
       {
  title: 'Foto del producto',
  dataIndex: 'imagen',
  key: 'imagen',
  render: (imagen) => (
    imagen ? (
      <Image
        width={60}
        src={imagen}
        alt="Imagen del producto"
        style={{ objectFit: 'cover', borderRadius: 4 }}
      />
    ) : (
      <span>-</span>
    )
  ),
},

  
        {
            title: 'Producto',
            dataIndex: 'nombre',
            key: 'nombre',
        },
        {
            title: 'Marca',
            dataIndex: ['Marca', 'nombre'],
            key: 'marca',
        },
      {
  title: 'Talles',
  key: 'talles',
  render: (_, record) => {
    const esZapatilla = record.Categorium?.nombre?.toLowerCase() === 'zapatillas';
    const nombresTalles = record.talles
      .map(t => esZapatilla ? t.talles_zapas || t.nombre : t.nombre)
      .join(', ');
    return <span>{nombresTalles || '-'}</span>;
  }
},

        {
            title: 'Color',
            key: 'colores',
            render: (_, record) => {
                const nombresColores = record.colores.map(c => c.nombre).join(', ');
                return <span>{nombresColores}</span>;
            }
        },
        {
            title: 'Stock',
            dataIndex: 'stock',
            key: 'stock',
        },
        {
            title: 'Precio c/u',
            key: 'precio',
            render: (_, record) => (
                <Space>
                    <span>${record.precio}</span>
                </Space>
            ),
        },
        {
            title: 'Acciones',
            key: 'acciones',
            render: (_, record) => (
                <Space>
                    <Button
                        type="link"
                        onClick={() => mostrarModalEdicion(record)}
                    >
                        <EditOutlined
                            style={{ fontSize: '18px', color: '#1890ff', cursor: 'pointer' }}

                        />
                    </Button>

                    <Popconfirm
                        title="¿Seguro que deseas eliminar este producto?"
                        onConfirm={() => eliminarProducto(record.id)}
                        okText="Sí"
                        cancelText="No"
                    >
                        <DeleteOutlined style={{ color: 'red', fontSize: '18px', cursor: 'pointer' }} />
                    </Popconfirm>
                </Space>
            ),
        }

    ];
    const handleMenuClick = (e) => {
        // Aquí puedes decidir si quieres cerrar el menú o no
        if (e.key === 'limpiar' || e.key === 'excel') {
            // Si quieres que se cierre, cierra el menú
            setDropdownVisible(false);
        } else {
            // Si quieres que no se cierre, no hagas nada o mantén abierto
        }
    };

    const handleVisibleChange = (flag) => {
        setDropdownVisible(flag);
    };


    const mobileMenu = (
        <Menu onClick={handleMenuClick}>
            <Menu.Item key="categoria">
                <Select
                    placeholder="Tipo de producto"
                    style={{ width: '100%' }}
                    allowClear
                    value={filters.categoria || undefined}
                    onChange={(value) => setFilters({ ...filters, categoria: value })}
                >
                    {categorias.map((cat) => (
                        <Option key={cat} value={cat}>{cat}</Option>
                    ))}
                </Select>
            </Menu.Item>
            <Menu.Item key="marca">
                <Select
                    placeholder="Marca"
                    style={{ width: '100%' }}
                    allowClear
                    value={filters.marca || undefined}
                    onChange={(value) => setFilters({ ...filters, marca: value })}
                >
                    {marcas.map((marca) => (
                        <Option key={marca} value={marca}>{marca}</Option>
                    ))}
                </Select>
            </Menu.Item>

            <Menu.Item key="genero">
                <Select
                    placeholder="Genero"
                    style={{ width: '100%' }}
                    allowClear
                    value={filters.genero || undefined}
                    onChange={(value) => setFilters({ ...filters, genero: value })}
                >
                    {genero.map((genero) => (
                        <Option key={genero} value={genero}>{genero}</Option>
                    ))}
                </Select>
            </Menu.Item>
            <Menu.Item key="limpiar">
                <Button
                    onClick={() => {
                        setSearchText('');
                        setFilters({ categoria: null, marca: null });
                    }}
                    block
                >
                    Limpiar filtros
                </Button>
            </Menu.Item>
            <Menu.Item key="excel">
                <Button
                    type="primary"
                    onClick={exportToExcel}
                    icon={<DownloadOutlined />}
                    block
                >
                    Exportar Excel
                </Button>
            </Menu.Item>
        </Menu>
    );
    return (
        <div>
                 <div
                  style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'row' : '',
                    alignItems: isMobile ? 'flex-start' : 'center',
                    justifyContent: 'space-between',
                    gap: '1rem',
                    marginBottom: 24,
                    padding: isMobile ? '20px' : 0,

                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>

              <Typography.Title level={3}  style={{ margin: 0}} >📦 Mis Productos</Typography.Title>
                </div>
       

                    <Dropdown overlay={mobileMenu} trigger={['click']} visible={dropdownVisible}
                        onVisibleChange={handleVisibleChange}>
                        <Button icon={<EllipsisOutlined />} />
                    </Dropdown>


            </div>
            <div style={{ marginBottom: 16 }}>

                <Search
                    placeholder="Buscar por nombre o categoría"
                    allowClear
                    enterButton="Buscar"
                    size="large"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    onSearch={() => aplicarFiltros()}
                         style={{
                        width: '100%',
                        maxWidth: '600px',
                        display: 'block',
                        padding: '0 10px',
                        boxSizing: 'border-box',
                    }}
                />

         
            </div>


            {isMobile ? (
                <List
                    dataSource={productosFiltrados}
                    loading={loading}
                    renderItem={item => (
                  <Card
            style={{ marginBottom: 16 }}
            title={item.nombre}
            extra={<span style={{ fontSize: 12, color: '#888' }}>{item.codigoProducto}</span>}
        >
            <p><strong>Marca:</strong> {item.Marca?.nombre}</p>
            <p><strong>Categoría:</strong> {item.Categorium?.nombre}</p>
            <p><strong>Género:</strong> {item.Genero?.nombre}</p>
            <p><strong>Precio:</strong> ${item.precio}</p>
            <p><strong>Stock:</strong> {item.stock}</p>
            <p><strong>Talles:</strong> {item.talles.map(t => t.nombre).join(', ') || '-'}</p>
            <p><strong>Colores:</strong> {item.colores.map(c => c.nombre).join(', ') || '-'}</p>

            <div style={{ display: 'flex', gap: 16, marginTop: 8 }}>
                <EditOutlined
                    style={{ fontSize: 18, color: '#1890ff', cursor: 'pointer' }}
                    onClick={() => mostrarModalEdicion(item)}
                />
                <Popconfirm
                    title="¿Seguro que quieres eliminar este producto?"
                    onConfirm={() => eliminarProducto(item.id)}
                    okText="Sí"
                    cancelText="No"
                >
                    <DeleteOutlined style={{ fontSize: 18, color: 'red', cursor: 'pointer' }} />
                </Popconfirm>
            </div>
        </Card>
                    )}
                />
            ) : (

            <Table
                dataSource={productosFiltrados}
                columns={columns}
                rowKey="id"
                loading={loading}
                pagination={{ pageSize: 10 }}
                scroll={{ x: 'max-content' }}
            />
            )}

            <Modal
                title="Editar Producto"
                visible={modalVisible}
                onCancel={cerrarModal}
                footer={null}
            >
                <ActualizarProducto productoSeleccionado={productoSeleccionado} setModalVisible={setModalVisible} fetchProductos={fetchProductos} />
            </Modal>

        </div>
    );
};

export default MisProductos;
